import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { KwkFacade } from '@zero/self-service/domain';
import { CopyToClipboardComponent } from '@zero/shared/ui-web-design-system';

@Component({
  selector: 'self-service-self-service-kwk',
  templateUrl: './self-service-kwk.component.html',
  imports: [CopyToClipboardComponent, AsyncPipe],
})
export class SelfServiceKwkComponent {
  public readonly kwkFacade = inject(KwkFacade);
}
